const theme = {
  colors: {
    transparent: "transparent",
    current: "currentColor",
    black: {
      300: "#364152", // Exercise secondary text / labels
      600: "#001302",
      700: "#011B33",
      800: "#00000040", // Popup BG
      900: "#000000",
      DEFAULT: "#000000",
    },
    blue: {
      400: "#D0EBFF",
      500: "#3677FF",
      600: "#1F63F2",
      700: "#1570EF", // Exercise intensity helper / info accent
      800: "#123BA3",
      DEFAULT: "#3677FF",
    },
    brown: {
      500: "#854F28",
      DEFAULT: "#854F28",
    },
    gray: {
      50: "#F9F9F9", // Exercise icon / nav chip BG
      75: "#EEF2F6", // Progress track / search / info BG
      100: "#ECECEC",
      200: "#E8E8E8", // Border
      300: "#E7E7E7",
      400: "#ABABAB",
      450: "#9AA4B2", // Exercise secondary meta text
      500: "#A7A7A7", // Content
      600: "#707070",
      700: "#5F6D7E", // Avatar BG
      800: "#5A5A5A",
      extras: {
        100: "#707070",
        200: "#EEF2F6A8",
      },
      DEFAULT: "#707070",
    },
    green: {
      100: "#F3FFF5", // Exercise activity icon wrap
      200: "#D4F6E4", // Primary BG
      300: "#A6FFD1",
      400: "#68DB9F",
      500: "#4ABE82",
      600: "#3EB176",
      700: "#329763",
      DEFAULT: "#4ABE82",
    },
    orange: {
      300: "#FFE9E5",
      400: "#FFDEE9",
      500: "#FD6E5E",
      DEFAULT: "#FD6E5E",
      extras: {
        500: "#F79009",
      },
    },
    red: {
      200: "#F5E0E7",
      300: "#FD6E5E",
      400: "#FE4365",
    },
    pink: {
      500: "#FFA588",
      DEFAULT: "#FFA588",
    },
    purple: {
      100: "#E5E4FF",
      200: "#463DE1",
      300: "#D156FF",
      400: "#E8E4FF",
      500: "#362391",
      DEFAULT: "#362391",
    },
    white: {
      100: "#FFFFFF",
      200: "#FAFAFA", // Input BG
      300: "#F5F5F9", // IconButton BG
      400: "#F2F3F4", // Screen BG
      DEFAULT: "#FFFFFF",
    },
    yellow: {
      100: "#FFFAEB",
      400: "#FFF7DD",
      500: "#FFCC00",
      600: " #FFB85F",
      DEFAULT: "#FFCC00",
    },
    ink: {
      600: "#4B5565",
      700: "#364152",
      900: "#0D121C",
    },
    extras: {
      "border-dark": "#CDCDCD",
    },
  } as const,
  extend: {
    backgroundImage: {
      "auth-login": "url('@ch/assets/images/auth-login-bg.webp')",
      "auth-landing": "url('@ch/assets/images/auth-landing-bg.webp')",
      "subscription-card-bg-pattern":
        "url('@ch/assets/images/GreenCardBackground.svg')",
      "auth-register": "url('@ch/assets/images/auth-register-bg.webp')",
      "auth-verify-account":
        "url('@ch/assets/images/auth-verify-account-bg.webp')",
      "auth-personal-info":
        "url('@ch/assets/images/auth-personal-info-bg.webp')",
      "auth-password-reset":
        "url('@ch/assets/images/auth-password-reset-bg.webp')",
    },
  },
} as const;

export default theme;
